import React from "react";
import {CREDITO, decimalAdjust} from "../../Global";
import {isNumber, showErrorMsg} from "../../helpers/validators";
import TablaPagosComponent from "./TablaPagosComponent";

export default class FormPagoComprobante extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            payload: {},
            tiposPago: [],
            pagos: [...props.deuda.pagos],
            restante: props.deuda.saldo,
        }
        this.onChangeFields = this.onChangeFields.bind(this);
        this.onProcesarHanler = this.onProcesarHanler.bind(this);
        this.onAddPagosHandler = this.onAddPagosHandler.bind(this);
        this.onEliminarPagoHandler = this.onEliminarPagoHandler.bind(this);
        this.procesarPago = this.procesarPago.bind(this);
    }

    async componentDidMount() {
        await this.fetchTiposPago();
    }

    async fetchTiposPago() {
        try {
            const res = await fetch('/api/pagos/tipopagos');
            const data = await res.json();
            if (data && data.respuesta) {
                // Filtramos el ID 6 (Crédito) según lo solicitado
                const filtrados = data.respuesta.filter(t => t.IdTipoPago !== 6);
                this.setState({ tiposPago: filtrados });
                
                // Inicializar IdTipoPago para pagos pendientes si no lo tienen
                let pagos = [...this.state.pagos];
                let modified = false;
                pagos.forEach(p => {
                    if (p.Estado === "PENDIENTE" && !p.IdTipoPago && filtrados.length > 0) {
                        p.IdTipoPago = filtrados[0].IdTipoPago;
                        modified = true;
                    }
                });
                if (modified) this.setState({ pagos });
            }
        } catch (error) {
            console.error("Error fetching tipos pago:", error);
        }
    }

    onChangeFields(e, pagoItem) {
        let pagos = [...this.state.pagos];
        let pago = pagos.find(p => p.IdPago === pagoItem.IdPago);
        pago[e.target.getAttribute('name')] = e.target.value;
        if (e.target.getAttribute('name') === "IdTipoPago") {
            const tipo = this.state.tiposPago.find(t => t.IdTipoPago === Number(e.target.value));
            if (tipo) pago.TipoPago = tipo.Nombre;
        }
        pago.capital = pago.Monto - pago.TotalPagado
        this.setState({pagos: pagos})
    }

    async onProcesarHanler(e, p) {
        if (isNumber(p.TotalPagado) && p.TotalPagado > 0) {
            await this.procesarPago(p);
        } else
            showErrorMsg("El total pagado tiene que ser un número mayor que 0.")
    }

    async procesarPago(p) {
        let pagos = [...this.state.pagos];
        const i = pagos.indexOf(p);
        pagos[i].Estado = await this.updatePago(p);
        this.setState({pagos: pagos, restante: this.state.restante - pagos[i].TotalPagado});
    }

    async updatePago(p) {
        this.setState({isLoading: true})
        let res = await fetch(`/api/creditos/procesar-pago?idPago=${p.IdPago}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            body: JSON.stringify({
                totalPagado: p.TotalPagado,
                idTipoPago: p.IdTipoPago,
                numMovimiento: p.NumeroMovimiento,
                pagosTable: this.props.deuda.pagosTable,
                pagosPk: this.props.deuda.pagosPk,
            })
        })
        let json = await res.json();
        this.setState({isLoading: false})
        return json.estado;
    }

    async onAddPagosHandler() {
        let pago = await this.addPago();
        let pagos = [...this.state.pagos];
        pagos.push(pago);
        this.setState({pagos: pagos});
    }

    async addPago() {
        this.setState({isLoading: true})
        let res = await fetch(`/api/creditos/add-pago`, {
            method: "POST",
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                idVenta: this.props.deuda.IdRegistroVenta,
                idTipoPago: CREDITO,
                monto: this.state.restante,
                pagosTable: this.props.deuda.pagosTable,
                pagosPk: this.props.deuda.pagosPk,
                referencePk: this.props.deuda.referencePk
            })
        })
        let json = await res.json()
        this.setState({isLoading: false})
        return {...json.pago, capital: json.pago.Monto - json.pago.TotalPagado};
    }

    async onEliminarPagoHandler(e, p) {
        let pagos = [...this.state.pagos]
        await this.deletePago(p.IdPago)
        pagos.splice(pagos.indexOf(p), 1)
        this.setState({pagos: pagos})
    }

    async deletePago(idPago) {
        this.setState({isLoading: true})
        await fetch(`/api/creditos/delete-pago?idPago=${idPago}`, {
            method: "DELETE",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                pagosTable: this.props.deuda.pagosTable,
                pagosPk: this.props.deuda.pagosPk,
            })
        });
        this.setState({isLoading: false})
    }

    render() {
        const {tiposPago, pagos, restante} = this.state;

        if (this.state.isLoading)
            return (
                <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                    </div>
                </div>
            )
        return (
            <div>
                <div className="container mt-1 mb-1 d-flex justify-content-between">
                    <div className="">
                        Total restante: {decimalAdjust('floor', restante, -2)}
                    </div>
                    <div className="">
                        {Number(decimalAdjust('floor', restante, -2)) > 0 ? (
                            <button
                                onClick={this.onAddPagosHandler}
                                className="btn btn-verde-mfp">
                                Agregar
                            </button>
                        ) : null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <TablaPagosComponent pagos={pagos} onProcesar={this.onProcesarHanler}
                                             readOnly={false}
                                             onChangeFields={this.onChangeFields}
                                             isLoading={this.state.isLoading}
                                             tiposPago={tiposPago}
                                             onEliminar={this.onEliminarPagoHandler}/>
                    </div>
                </div>

            </div>
        );
    }
}
